"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserTitleUpdater = exports.BrowserTitleUpdateType = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
// The BrowserTitleUpdateTypes should align with the applicable public helper methods in
// VPC's BrowserTitleService.ts which get called through UIActions
var BrowserTitleUpdateType;
(function (BrowserTitleUpdateType) {
    BrowserTitleUpdateType["TITLE_WITH_PLACE_ENTITY_NAME"] = "TITLE_WITH_PLACE_ENTITY_NAME";
    BrowserTitleUpdateType["TITLE_WITH_PLACE_NAME_FUNCTION"] = "TITLE_WITH_PLACE_NAME_FUNCTION";
    BrowserTitleUpdateType["TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME"] = "TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME";
})(BrowserTitleUpdateType = exports.BrowserTitleUpdateType || (exports.BrowserTitleUpdateType = {}));
var BrowserTitleUpdater = /** @class */ (function (_super) {
    __extends(BrowserTitleUpdater, _super);
    function BrowserTitleUpdater() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserTitleUpdater.prototype.render = function () {
        var _this = this;
        var name = this.props.browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_PLACE_ENTITY_NAME ||
            this.props.browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME ?
            this.props.name
            : '';
        return (react_1.default.createElement(data_catalog_shared_1.UIActionsContext.Consumer, null, function (uiActions) {
            return react_1.default.createElement(BrowserTitleUIActionsUpdater, { browserTitleUpdateType: _this.props.browserTitleUpdateType, uiActions: uiActions, name: name, nameFunction: _this.props.browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_PLACE_NAME_FUNCTION ?
                    _this.props.nameFunction
                    : function () { return ''; }, subspaceName: _this.props.browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME ?
                    _this.props.subspaceName : '' });
        }));
    };
    return BrowserTitleUpdater;
}(react_1.default.Component));
exports.BrowserTitleUpdater = BrowserTitleUpdater;
var BrowserTitleUIActionsUpdater = /** @class */ (function (_super) {
    __extends(BrowserTitleUIActionsUpdater, _super);
    function BrowserTitleUIActionsUpdater() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localIsMounted = false;
        return _this;
    }
    BrowserTitleUIActionsUpdater.prototype.componentDidMount = function () {
        this.localIsMounted = true;
        this.updateBrowserTitle();
    };
    BrowserTitleUIActionsUpdater.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.name !== prevProps.name || this.props.nameFunction !== prevProps.nameFunction ||
            this.props.uiActions !== prevProps.uiActions) {
            this.updateBrowserTitle();
        }
    };
    BrowserTitleUIActionsUpdater.prototype.updateBrowserTitle = function () {
        var _this = this;
        // setTimeout of 0 is used here to ensure that our browser title update gets called after VPC's set default browser title call
        setTimeout(function () {
            if (_this.localIsMounted) {
                _this.makeUpdateBrowserTitleUiActionsCall();
            }
        }, 0);
    };
    BrowserTitleUIActionsUpdater.prototype.makeUpdateBrowserTitleUiActionsCall = function () {
        switch (this.props.browserTitleUpdateType) {
            case BrowserTitleUpdateType.TITLE_WITH_PLACE_ENTITY_NAME: {
                if (this.props.name) {
                    this.props.uiActions.setBrowserTitleWithPlaceEntityName(this.props.name);
                }
                break;
            }
            case BrowserTitleUpdateType.TITLE_WITH_PLACE_NAME_FUNCTION: {
                if (this.props.nameFunction) {
                    this.props.uiActions.setBrowserTitleWithPlaceNameFunction(this.props.nameFunction);
                }
                break;
            }
            case BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME: {
                if (this.props.name) {
                    this.props.uiActions.setBrowserTitleWithSpaceEntityNameAndTranslatedSubspaceName(this.props.name, this.props.subspaceName);
                }
                break;
            }
            default:
                break;
        }
    };
    BrowserTitleUIActionsUpdater.prototype.render = function () {
        return null;
    };
    BrowserTitleUIActionsUpdater.prototype.componentWillUnmount = function () {
        this.localIsMounted = false;
    };
    return BrowserTitleUIActionsUpdater;
}(react_1.default.Component));
//# sourceMappingURL=BrowserTitleUpdater.js.map